import React, { isValidElement } from 'react';
import '../../utils/assertions.es.js';
import '../../utils/responsive.es.js';
import '../../utils/scrollIntoView.es.js';
import 'polished';
import '@styled-system/css';
import 'styled-components';
import '../../utils/useEnhancedEffect.es.js';
import 'react-is';
import { filterChildrenByType } from '../../utils/filterChildrenByType/filterChildrenByType.es.js';
import { findChildByType } from '../../utils/findChildByType/findChildrenByType.es.js';
import { Input } from '../Input/Input.es.js';
import { ChipInput } from '../ChipInput/ChipInput.es.js';
import { InputGroupAddon, InputGroupIcon, InputGroupIconButton, InputGroupButton, InputGroupText } from './InputGroupAddon.es.js';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const InputGroup = (_a) => {
  var _b = _a, { children } = _b, props = __objRest(_b, ["children"]);
  const childrenArray = React.Children.toArray(children);
  const addonClones = filterChildrenByType(childrenArray, [
    InputGroupAddon,
    InputGroupIcon,
    InputGroupIconButton,
    InputGroupButton,
    InputGroupText
  ]);
  const addonLeft = addonClones.filter((addon) => addon.props.placement === "left");
  const addonRight = addonClones.filter((addon) => addon.props.placement === "right");
  const inputElement = findChildByType(childrenArray, [Input, ChipInput]);
  if (!isValidElement(inputElement))
    return /* @__PURE__ */ React.createElement(React.Fragment, null);
  return React.cloneElement(inputElement, __spreadValues({
    addonLeft,
    addonRight
  }, props));
};
InputGroup.displayName = "InputGroup";
var InputGroup$1 = Object.assign(InputGroup, {
  Addon: InputGroupAddon,
  Icon: InputGroupIcon,
  IconButton: InputGroupIconButton,
  Button: InputGroupButton,
  Text: InputGroupText
});

export { InputGroup$1 as default };
//# sourceMappingURL=InputGroup.es.js.map
